import classNames         from 'classnames';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import * as PropTypes     from 'prop-types';

import useEventListener from '../../../common/hooks/useEventListener';

const CatalogCollapsible = function(props) {
  const { t } = useTranslation();

  const { children = [] } = props;

  const nodes = React.useRef({});

  const [isCollapsible, setIsCollapsible] = React.useState(false);
  const [isOpen, setIsOpen]               = React.useState(false);

  const getHeight      = React.useCallback(() => {
    return Object
      .values(nodes.current)
      .reduce((acc, cur) => {
        return acc + (cur?.offsetHeight || 0);
      }, 0);
  }, []);
  const onResize       = React.useCallback(() => {
    setIsCollapsible(getHeight() + 30 >= (window.screen.width >= 991 ? 200 : 150));
  }, [getHeight]);
  const renderChildren = React.useCallback(() => (
    React.Children.map(children, (child, index) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          ...child.props,
          ref: (node) => {
            if (typeof child.props.ref === 'function') {
              child.props.ref(node);
            }

            nodes.current[index] = node;
          },
        });
      }
    })
  ), [children]);
  const toggleOpen     = React.useCallback(() => {
    setIsOpen((isOpen) => !isOpen);
  }, []);

  useEventListener('resize', onResize);

  React.useEffect(() => {
    onResize();
  }, [isCollapsible]);

  return (
    <>
      {isCollapsible && children.length > 0
        ? (
          <div className={classNames('collapsible', { open: isOpen })}>
            <div className={classNames('collapse', { isCollapsible: isCollapsible })}>
              {renderChildren()}
            </div>
            <div
              className={'trigger'}
              onClick={toggleOpen}
            >
              {isOpen ? t('hide') : t('client_read_completely')}
              <span className={'ic-arrow-bottom'} />
            </div>
          </div>
        )
        : renderChildren()
      }
    </>
  );

};

CatalogCollapsible.propTypes = {
  children: PropTypes.node,
};

export default CatalogCollapsible;